module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wxsx-dialog-wrap"
  }, [(!(_vm.cvipMes.cvipstate == 1 || _vm.cvipMes.cvipstate == 10)) ? _c('CvipDialog', {
    attrs: {
      "title": _vm.title,
      "btnTxt": _vm.btnTxt
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "des"
  }, [_vm._v("特权介绍："), _c('span', {
    staticClass: "des-in"
  }, [_vm._v("非会员每天只能刷新一次，会员可享受免费刷新权限。")])]), _vm._v(" "), _c('div', {
    staticClass: "wxsx-bg"
  }, [_c('img', {
    staticClass: "wxsx-bg-img",
    attrs: {
      "src": require("../../../../assets/imgs/pri-wxsx.png")
    }
  })])]) : _c('CvipDialog', {
    attrs: {
      "title": _vm.title1,
      "btnTxt": _vm.btnTxt1
    },
    on: {
      "btnClick": function($event) {
        return _vm.vipBuy()
      },
      "close": function($event) {
        return _vm.close()
      }
    }
  }, [_c('p', {
    staticClass: "tit"
  }, [_vm._v("恭喜您，已获得"), _c('span', {
    staticClass: "tit-names"
  }, [_vm._v("免费刷新")]), _vm._v("特权")]), _vm._v(" "), _c('p', {
    staticClass: "des"
  }, [_c('span', {
    staticClass: "des-in des-use"
  }, [_vm._v("特权介绍：非会员每天只能刷新一次，会员可享受免费刷新权限。")])]), _vm._v(" "), _c('div', {
    staticClass: "wxsx-bg"
  }, [_c('img', {
    staticClass: "wxsx-bg-img",
    attrs: {
      "src": require("../../../../assets/imgs/pri-wxsx.png")
    }
  })])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-12f0a829"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/index/modules/dialog/WxsxDialog.vue
// module id = XT4T
// module chunks = 1